import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { FC } from 'react';
import MBFooterV2 from '../../components/MBFooterV2/MBFooterV2';

type TPageLayoutProps = {
    showFooter?: boolean;
    testId?: string;
};

const Screen = styled('div')(({ theme }) => ({
    backgroundColor: '#ffffff',
    width: '100%',
    minHeight: '100vh',
}));

const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '466px',
    minWidth: '300px',
    margin: '0 auto',
    minHeight: '100vh',
    padding: '20px',
}));

const PageLayoutV2: FC<TPageLayoutProps> = (props) => {
    const { children, showFooter = true, testId } = props;
    return (
        <Screen data-testid={testId ? testId : undefined}>
            <Container>
                <Box component={'main'}>{children}</Box>
                {showFooter && (
                    <Box sx={{ mt: 'auto' }}>
                        <MBFooterV2 />
                    </Box>
                )}
            </Container>
        </Screen>
    );
};

export default PageLayoutV2;
